import React, { memo, useMemo, useState, useCallback, useEffect } from "react";
import { Loader } from "../../CoreUI";
// import SurfaceOverlay from "../../SurfaceOverlay";
import TrackerWrapper from "../../TrackerWrapper";

import useResource from "../../../hooks/useResource";

import getApiUrl from "../../../utils/getApiUrl";
import GET from "../../../utils/GET";

import "./platform-preview.css";
import SurfaceManager from "../../SurfaceManager";

const surveyPreview = GET("surveyPreview");
const offerPreview = GET("offerPreview");
const rewardsPreview = GET("rewardsPreview");
const flowPreview = GET("flowPreview");
const shopifyOrderID = GET("shopifyOrderID");
const customPreviewID = GET("customPreviewID") || null;
const host = GET("host");

const moduleType = surveyPreview
	? "survey"
	: offerPreview
	? "offer"
	: rewardsPreview
	? "rewards"
	: flowPreview
	? "flow"
	: "";

const publisher = GET("publisher");

const PlatformPreview = memo(({ callRewardApi, innerHeight, offsetTop }) => {
	const [previewData, setPreviewData] = useState();
	const [customLoading, setCustomLoading] = useState(true);

	const onClose = useCallback(() => {
		return;
	}, []);

	const defaultPreviewProps = useMemo(
		() => ({
			data: previewData,
			rewardResponseTrigger: callRewardApi,
			innerHeight,
			offsetTop,
			onClose,
			preview: true,
		}),
		[previewData, onClose, callRewardApi, innerHeight, offsetTop]
	);

	const [{ data, loading, error }, fetchPreviewData, , , resetPreviewData] =
		useResource(
			`${getApiUrl()}/core/modules_preview/${publisher}/`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					module_type: moduleType,
					module_id: customPreviewID,
					shopify_order_id: shopifyOrderID,
					url: host,
				}),
			},
			false
		);

	useEffect(() => {
		if (!moduleType) {
			setCustomLoading(false);
			return;
		}
		fetchPreviewData();
	}, [fetchPreviewData]);

	useEffect(() => {
		if (data) {
			setCustomLoading(false);
			setPreviewData(data);
			resetPreviewData();
		}
		if (error) {
			setCustomLoading(false);
		}
	}, [data, resetPreviewData, error]);

	if (error || !moduleType) {
		return null;
	}

	return (
		<TrackerWrapper data={previewData}>
			<section
				className="platform-preview-container"
				style={{
					backgroundColor:
						previewData?.publisher_details?.modal_color || "#fff",
				}}
			>
				{loading || customLoading ? (
					<Loader center />
				) : (
					previewData && (
						<>
							{/* <SurfaceOverlay {...defaultPreviewProps} /> */}
							<SurfaceManager {...defaultPreviewProps} />
						</>
					)
				)}
			</section>
		</TrackerWrapper>
	);
});

export default PlatformPreview;
